import { useCallback, useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./Pricing.scss";
import { useParams, useNavigate, Link } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { NotificationManager } from "react-notifications";
import { Tag } from "../../utils/GTMPageTag";
import OrderFormMailbox from "../../components/order/OrderFormMailbox";
import OrderFormPhone from "../../components/order/OrderFormPhone";

import {
  getPageContent,
} from "../../api/apiRequest";
import { useLangContext } from "../../context/languageContext";

const PricingMailbox = (props) => {
  Tag("PricingMailbox")
  const defaultTab = props.tab ?? 'geschaeftsadresse';
  const navigate = useNavigate();
  const { hostLanguage } = useLangContext();
  const { country, city, type, area } = useParams();


  const [selectTab, setSelectedTab] = useState(defaultTab);
  const handleTabSelect = (tab_type) => {
    setSelectedTab(tab_type);
    if(!( 
      country !== undefined && country !== "" && 
      city !== undefined && city !== "" && 
      type !== undefined && type !== "" &&
      area !== undefined && area !== ""
    )){
      if( tab_type === 'geschaeftsadresse' ){
        window.history.replaceState({}, null, props.link+'/geschaeftsadresse');
      }else if( tab_type === 'telefonnummer' ){
        window.history.replaceState({}, null, props.link+'/telefonnummer');
      }
    }
  };

  const [contentDetails, setContentDetails] = useState();
  const getAllPageContent = useCallback(async () => {
    try {
      let apiRes = await getPageContent(hostLanguage, "pricing_mail_box_page_data");
      let responseData = await apiRes.json();
      if (responseData.res) {
        setContentDetails(responseData.data);
        // console.warn(responseData.data.header);
      } else {
        NotificationManager.error(responseData.msg, "", 2000);
      }
    } catch (error) {
      console.error(error);
    }
  },[hostLanguage]);


  useEffect(() => {
    getAllPageContent();
  }, [getAllPageContent]);

  return (
    <div id="PricingMailbox" className="MainbBody">
      <div className="PricelistBanner">
        <Container>
          <Row>
            <Col sm={12}>
              {/* <p>CleverDomizil</p> */}
              {/* <h3>Preisliste</h3> */}
              <div
                dangerouslySetInnerHTML={{
                  __html:
                    contentDetails?.pricing_mail_box_page_data?.banner_text,
                }}
              ></div>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="PricelistBody">
        <Container>
          <Row>
            <Col sm={12}>
              {/* <h3>Wählen Sie Ihr gewünschtes Produkt aus!</h3> */}
              <div
                dangerouslySetInnerHTML={{
                  __html:
                    contentDetails?.pricing_mail_box_page_data?.page_heading,
                }}
              ></div>
            </Col>
          </Row>
          <Row className="PricelistTab">
            <Col sm={12}>
              <Tabs
                defaultActiveKey={defaultTab}
                id="uncontrolled-tab-example"
                className="mb-3"
                onSelect={handleTabSelect}
              >
                {/* <Tab eventKey="mailbox" title="Geschäftsadresse"> */}
                <Tab
                  eventKey="geschaeftsadresse"
                  title={
                    contentDetails?.pricing_mail_box_page_data?.tab_1_text ?? 'Tab1'
                  }
                >
                  <div className="PlanScetion">
                    <Container className="">
                      <Row>
                        <Col sm={12}>
                          <div className="ScetionTitel mb-0">
                            <div
                              dangerouslySetInnerHTML={{
                                __html:
                                  contentDetails?.pricing_mail_box_page_data
                                    ?.tab_1_product_heading,
                              }}
                            ></div>
                          </div>
                        </Col>
                      </Row>
                    </Container>
                  </div>
                  
                  {selectTab  === 'geschaeftsadresse' ?
                    <OrderFormMailbox navigateLink={props.link+'/geschaeftsadresse'} />
                    : null
                  }
                  <Link className="BtnSubmit btn btn-primary mt-4" to='/faq'>FAQ</Link>
                </Tab>
                {/* <Tab eventKey="phonenumber" title="Rufnummer"> */}
                <Tab
                  eventKey="telefonnummer"
                  title={
                    contentDetails?.pricing_mail_box_page_data?.tab_2_text ?? 'Tab2'
                  }
                >
                  <div className="PlanScetion">
                    <Container className="">
                      <Row>
                        <Col sm={12}>
                          <div className="ScetionTitel mb-0">
                            <div
                              dangerouslySetInnerHTML={{
                                __html:
                                  contentDetails?.pricing_mail_box_page_data
                                    ?.tab_2_heading,
                              }}
                            ></div>
                          </div>
                        </Col>
                      </Row>
                    </Container>
                  </div>
                  {selectTab  === 'telefonnummer' ?
                    <OrderFormPhone navigateLink={props.link+'/telefonnummer'}/>
                    : null
                  }
                  <Link className="BtnSubmit btn btn-primary mt-4" to='/FAQ'>FAQ</Link>
                </Tab>
              </Tabs>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default PricingMailbox;
